export default __webpack_public_path__ + "media/images/faq/hero1920-64c88b4e9386f8961aa4c2164fa5d4bf.jpg";